import { useMetadataFieldsQuery } from '../../api'
import { Select, SelectItem, TextField } from '@calabriocloud/beacon-ui'
import { FieldProps } from './constants'
import { useTranslation } from 'react-i18next'
import { Key, useEffect, useState } from 'react'

export const MetadataField = ({ classifier, field, onChange }: FieldProps) => {
  const { t } = useTranslation()
  const { data, isLoading } = useMetadataFieldsQuery()
  const [metadataValue, setMetadataValue] = useState<string>('')
  const [selectedField, setSelectedField] = useState<Key | undefined>(undefined)
  const hasValue = classifier.id === 6
  const baseValue = { classifierType: classifier.id, field: null }

  useEffect(() => {
    // update when both are set
    if (isLoading || !data) return
    const metadataField = data?.find(item => item.key === selectedField)
    if (hasValue && metadataValue.length > 0 && selectedField && metadataField) {
      // TODO: Add translation for metadata with value
      onChange({
        ...baseValue,
        field: metadataValue,
        fieldKey: metadataField.key,
        name: `${t(classifier.name)}: Field ${metadataField.name} Value ${metadataValue}`,
      })
    } else if (!hasValue && selectedField && metadataField) {
      // TODO: Add translation for metadata with value
      onChange({ ...baseValue, fieldKey: metadataField.key, name: `${t(classifier.name)}: ${metadataField.name}` })
    }
  }, [isLoading, selectedField, metadataValue])


  let description = t('selectMetadata')
  if (isLoading) {
    description = t('loading')
  } else if (!data || data.length === 0) {
    description = t('noMetadataFields')
  }

  return (
    <div className='flex flex-row gap-4 pb-4'>
      <Select
        className='w-80'
        data-testid='classifier-metadata-select'
        label={t('metadataField')}
        placeholder={description}
        selectedKey={field?.fieldKey}
        onSelectionChange={setSelectedField}
        items={data || []}
      >
        {item => (
          <SelectItem>{item.name}</SelectItem>
        )}
      </Select>
      {
        hasValue && (
          <TextField data-testid='classifier-metadata-text-input' label={t('metadataValue')} value={metadataValue} onChange={setMetadataValue} />
        )
      }
    </div>
  )
}
